import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import styles from './Login.module.css';

const API = import.meta.env.VITE_API_URL || '/api';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, app: 'console' }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || '送信に失敗しました');
      }
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : '送信に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>ME</div>
          <div className={styles.logoText}>住縁 Mirai EMS</div>
        </div>
        <div className={styles.subtitle}>パスワードリセット</div>

        {sent ? (
          <>
            <p style={{ fontSize: 13, color: 'var(--ink2)', lineHeight: 1.7, marginBottom: 20 }}>
              入力されたメールアドレスにリセットリンクを送信しました。<br />
              メールをご確認ください。
            </p>
            <Link to="/login" className={styles.btn} style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }}>
              ログイン画面に戻る
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <p style={{ fontSize: 12, color: 'var(--ink3)', margin: '0 0 8px', lineHeight: 1.6 }}>
              登録済みのメールアドレスを入力してください。<br />
              パスワードリセット用のリンクをお送りします。
            </p>
            <div className={styles.field}>
              <label className={styles.label}>メールアドレス</label>
              <input className={styles.input} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
            </div>
            {error && <div className={styles.error}>{error}</div>}
            <button className={styles.btn} type="submit" disabled={loading}>
              {loading ? '送信中...' : 'リセットリンクを送信'}
            </button>
            <Link to="/login" style={{ fontSize: 12, color: 'var(--brand)', textAlign: 'center', marginTop: 8 }}>
              ログイン画面に戻る
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
